<svg [ngClass]="class" viewBox="0 0 358 254" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="176" cy="127" r="127" fill="#7C9696"/>
  <g clip-path="url(#clip0_17212_183141)">
    <ellipse cx="173" cy="158.5" rx="147" ry="25.5" stroke="#E3DBC0" stroke-width="2" stroke-dasharray="80 80"/>
    <ellipse cx="179" cy="158.5" rx="174" ry="44.5" stroke="#6F9696" stroke-width="2" stroke-dasharray="100 100"/>
    <path d="M75.6523 97.3279L173.074 117.933L114.636 157.864L75.6523 97.3279Z" fill="#6F9696"/>
    <path d="M272.569 113.659L173.074 117.933L224.524 167.002L272.569 113.659Z" fill="#6F9696"/>
    <path d="M114.664 157.89L169.083 162.395L176.967 67.3029L114.664 157.89Z" fill="#D1C8BA"/>
    <path d="M176.966 67.3029L169.082 162.395L223.885 166.926L176.966 67.3029Z" fill="#D1C8BA"/>
    <path d="M176.962 67.3029L171.535 119.879L169.078 162.395L173.66 120.058L176.962 67.3029Z" fill="#B79086"/>
    <path d="M114.664 157.89L172.462 125.894L224.218 166.977L114.664 157.89Z" fill="#B79086"/>
    <path d="M114.662 157.89L75.6523 97.3279L172.459 125.894L114.662 157.89Z" fill="#FBF2E5"/>
    <path d="M224.218 166.977L272.672 113.659L172.461 125.894L224.218 166.977Z" fill="#FBF2E5"/>
  </g>
  <defs>
    <clipPath id="clip0_17212_183141">
      <rect width="358" height="143" fill="white" transform="translate(0 60)"/>
    </clipPath>
  </defs>
</svg>
